import script from "./TaskFormDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskFormDialog.vue?vue&type=script&setup=true&lang=js"

import "./TaskFormDialog.vue?vue&type=style&index=0&id=325a2558&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-325a2558"]])

export default __exports__